import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav'
import { PageEvent, MatSnackBar } from '@angular/material';
import { SessionService } from '../../../service/session/session.module';
import * as Rx from 'rxjs';
// import { LoadingService } from '../../../directive/loading/loading.module';
// import * as moment from 'moment';
@Component({
  selector: 'app-maker',
  templateUrl: './maker.component.html',
  styleUrls: ['./maker.component.css']
})
export class MakerComponent implements OnInit {
  @ViewChild('drawer',{static:true})drawerCtrl: MatDrawer;
  paginatorModel = {
    total:0,
    pageSizeOptions:[ 2 ,5, 10, 25, 100, 200, 500, 1000],
  };
  metadata = {
    searchBoxInput: new Rx.Subject<string>(),
    object:{
      main:{
        uuid:''
      }
    }
  }
  // MatPaginator Output
  pageEvent: PageEvent;
  makerList = [];
  makerMin = {
    system: {
      status:true
    },
    max: 10,
    offset: 0,
    filter: {
      name: '',
      value: ''
    }
  }
  constructor(private session: SessionService, public snackBar: MatSnackBar) {
  //   this.metadata.searchBoxInput.debounceTime(700)
  //   .switchMap(val => {
  //     // console.log('called once',val)
  //     if(val != ''){
  //       this.makerList = [];
  //       this.makerMin.filter.name = 'searchElement';
  //     }else{
  //       this.makerList = [];
  //       this.makerMin.filter.name = '';
  //       this.makerMin.filter.value = '';
  //       val = 'false'
  //     }
  //     this.getmakerList();
  //     return val;
  //   }).subscribe(results => {
  //     // Modificaciones sobre cada letra si se requiere
  //   }, error => {
  //   console.log('error logged:');
  //   this.snackBar.open(error.message, 'Error', {duration: 5000});
  //   console.log(error);
  // });
   }

  ngOnInit() {
    this.getmakerList();
    this.drawerCtrl.opened = true;
  }

  // funcion para obtener la lista de medidas
  getmakerList() {
  // this.loadingService.wait();
    this.makerList = [];
    // verificamos en que pagina verificamos
    this.session.getRequest("maker:list", this.makerMin).subscribe(
      (data: any) => {
        this.makerList = data.object.instanceList;
        this.paginatorModel.total = data.object.total;
        // this.loadingService.hide();
      },
      error => {
        console.log("maker:list", error);
        // this.loadingService.hide();
      }
    );
  }

  /*
  Funcion para inactivar una unidad de medida
  */
  deleteAMaker(object) {
    // this.loadingService.wait();
    this.session.getRequest("maker:delete", object).subscribe(
      data => {
        this.snackBar.open('Marca eliminada correctamente', '', {
          duration: 8000
        });
        // this.loadingService.hide();
        for (var _i = 0; _i < this.makerList.length; _i++) {
          if (object.main.uuid == this.makerList[_i].main.uuid) {
            this.makerList.splice(_i, 1);
            break;
          }
        }
      },
      error => {
        console.log("Erro: maker:delete", error);
        // this.loadingService.hide();
      }
    );
  }

  /*
  Funcionalidad para colocar el objeto en el menu de opciones
  */
  objectSelected(object){
    for(let i=0; i < this.makerList.length; i++){
      this.makerList[i].main.selected = false;
    }
    if(object.main.uuid == this.metadata.object.main.uuid){
      object.main.selected = false;
      this.metadata.object.main.uuid = '';
    }else{
      object.main.selected = true;
      this.metadata.object = JSON.parse(JSON.stringify(object));;
    }
  }

  /*
    *Funcion para buscar
  */
  search(){
    this.metadata.searchBoxInput.next(this.makerMin.filter.value);
  }
  // funcion para obtener los datos del paginado.
  onPaginateChange(event){
    this.makerMin.offset = (event.pageIndex * event.pageSize);
    this.makerMin.max = event.pageSize;
    this.getmakerList();
  }

  handleUpdated(event) {
    this.makerMin.offset = (this.pageEvent ? this.pageEvent.pageIndex * this.pageEvent.pageSize  : this.makerMin.offset);
    this.getmakerList();
  }
 /*
 funcion para controlar si se abre o cierra el menu
 */
 toogleMenu(ev){
   this.drawerCtrl.opened = ev;
 }
}
